
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';
import Partnership from '../../../../components/docs/plaidoms/Partnership';
export const metadata = {
  toc: true,
  layout: 'guide',
  maxTocLevel: 4,
  skipLLM: true,
  description: "Use Sila Money with Plaid Auth to send and receive payments"
};
export const partnerProps = {
  partner: 'Sila Money',
  clientLibrary: 'sila_money',
  subtitle: metadata.description,
  registrationUrl: 'https://console.silamoney.com',
  apiUrl: 'https://docs.silamoney.com',
  isPaymentProcessor: true
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Callout = makeShortcode("Callout");
const layoutProps = {
  metadata,
partnerProps
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <Partnership.Header {...partnerProps} />
    <h4 {...{
      "id": "overview"
    }}>{`Overview`}</h4>
    <p><em parentName="p">{`What can you do with the Sila API?`}</em></p>
    <p>{`The Sila API endpoints enable you to:`}</p>
    <ul>
      <li parentName="ul">{`Same-day pre-approval for US registered companies operating in regulated industries`}</li>
      <li parentName="ul">{`Create digital wallets for your end-users with underlying funds held in FDIC member bank`}</li>
      <li parentName="ul">{`Store value using SILAUSD in digital wallets and transfer money compliantly in the U.S.`}</li>
      <li parentName="ul">{`Verify individual and business identities compliant with U.S. KYC & KYB regulations`}</li>
      <li parentName="ul">{`Link bank accounts, check balances, and identify owners via our partnership with Plaid`}</li>
      <li parentName="ul">{`Perform ACH debit and ACH credit transfers for U.S. citizens and permanent residents`}</li>
      <li parentName="ul">{`Program your app's money using business logic or self-executing smart contracts`}</li>
    </ul>
    <p><em parentName="p">{`Why use the Sila API?`}</em></p>
    <p>{`The Sila API was designed to help you:`}</p>
    <ul>
      <li parentName="ul">{`Off-board your U.S. compliance requirements`}</li>
      <li parentName="ul">{`Decrease your go-to-market time and upfront costs`}</li>
      <li parentName="ul">{`Reduce the number of APIs and vendors you use`}</li>
      <li parentName="ul">{`Minimize fraud using Sila's proprietary scoring models`}</li>
      <li parentName="ul">{`Move money 24/7 in real-time using SILAUSD`}</li>
    </ul>
    <p>{`Sila offers SDKs in JavaScript, Node, Python, .NET, and PHP as well as a Postman collection and API explorer demo application.`}</p>
    <h4 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h4>
    <Partnership.GettingStarted {...partnerProps} />
    <h4 {...{
      "id": "instructions"
    }}>{`Instructions`}</h4>
    <Partnership.AuthIdentityInstructions {...partnerProps} />
    <Partnership.Server {...partnerProps} />
    <h4 {...{
      "id": "launching-to-production"
    }}>{`Launching to Production`}</h4>
    <Callout mdxType="Callout">
      <p>{`You can work with Sila Money in either Sandbox (sandbox.plaid.com, allows testing with simulated users) or Production (production.plaid.com, requires Sila Money Production credentials). `}</p>
    </Callout>
    <Partnership.Conclusion {...partnerProps} />
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      {
        id: "overview",
        level: 4,
        title: "Overview",
      },
{
        id: "getting-started",
        level: 4,
        title: "Getting Started",
      },
{
        id: "instructions",
        level: 4,
        title: "Instructions",
      },
{
        id: "launching-to-production",
        level: 4,
        title: "Launching to Production",
      }
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
